// extracted by mini-css-extract-plugin
export default {"FeedbackModal":"FeedbackModal_FeedbackModal__aaF8U","message":"FeedbackModal_message__OCeEi","button":"FeedbackModal_button__TgQI8"};